import { PeekBox, PeekButton, PeekPaper, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import React from "react";
import { useTheme } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
import { useIntl } from "react-intl";
import { ChevronRight, Check } from "@piiqtechnologies/svg-icons";
const Banner = ({ title, description, imageSource, bannerTheme, items }) => {
    const theme = useTheme();
    const intl = useIntl();
    const onContactSalesClick = () => {
        window.open(process.env.PEEK_APP_CONTACT_US_URL, "_blank");
    };
    const onLearMoreClick = () => {
        window.open(process.env.PEEK_APP_SOLUTIONS_URL, "_blank");
    };
    return (React.createElement(PeekPaper, { sx: {
            height: bannerTheme === "light" ? theme.spacing(36.4) : theme.spacing(25.2),
            width: "100%",
            borderRadius: 2,
            overflow: "hidden",
            background: bannerTheme === "light" ? theme.palette.common.white : `linear-gradient(90deg, #35344B 0%, #7F7E8D 100%)`,
        } },
        React.createElement(PeekStack, { direction: "row", justifyContent: "space-between", spacing: theme.spacing(4) },
            React.createElement(PeekStack, { direction: "column", spacing: theme.spacing(2.6), my: "auto", ml: theme.spacing(3) },
                React.createElement(PeekStack, { direction: "column", spacing: theme.spacing(1.8) },
                    React.createElement(PeekTypography, { color: bannerTheme === "dark" ? theme.palette.common.white : theme.palette.text.primary, variant: "h2" }, title),
                    React.createElement(PeekTypography, { color: bannerTheme === "dark" ? theme.palette.common.white : theme.palette.text.primary, variant: "h4" }, description)),
                !!items && !!items.length && (React.createElement(PeekStack, { direction: "column", spacing: theme.spacing(1.5) }, items.map((item, index) => {
                    return (React.createElement(PeekStack, { key: index, direction: "row", spacing: theme.spacing(0.7), alignItems: "center" },
                        React.createElement(Check, { color: bannerTheme === "dark" ? theme.palette.common.white : theme.palette.text.primary }),
                        React.createElement(PeekTypography, { color: bannerTheme === "dark" ? theme.palette.common.white : theme.palette.text.primary, variant: "h4" }, item)));
                }))),
                React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: theme.spacing(3) },
                    React.createElement(PeekButton, { onClick: onContactSalesClick, size: "large", variant: "contained", color: "secondary" }, intl.formatMessage(messages.contactSales)),
                    React.createElement(PeekButton, { onClick: onLearMoreClick, variant: "text", endIcon: React.createElement(ChevronRight, { width: 14 }), color: "secondary", sx: {
                            boxShadow: "none",
                            ":hover": { background: "transparent" },
                        } }, intl.formatMessage(messages.learnMore)))),
            React.createElement(PeekBox
            /* @ts-ignore */
            , { 
                /* @ts-ignore */
                src: imageSource, height: "100%", width: bannerTheme === "light" ? "650px" : "460px", component: "img", alt: "Banner image" }))));
};
export default Banner;
